<template>
    <div class="px-4 py-5 sm:p-6">
        <dt class="text-sm font-normal">{{ title }}</dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
            <div class="flex items-baseline text-3xl font-semibold">
                {{ format(value, formatAs) }}{{ unit }}
                <span class="ml-2 text-sm font-medium"> {{$t('pages.analytics.comparison_badge.from')}} {{ format(comparisonValue, formatComparisonValueAs) }}{{ comparisonUnit }}</span>
            </div>

            <div class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-xs font-medium md:mt-2 lg:mt-0" :class="comparisonTrendStyles">
                <svg v-if="this.type === 'increase'" class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                </svg>
                <svg v-if="this.type === 'decrease'" class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only"> {{$t('pages.analytics.comparison_badge.increased_by')}}</span>
                <span v-if="this.type !== 'equal'">{{ comparisonTrend | toNumber(0,0) }}%</span>
            </div>
        </dd>
    </div>
</template>

<script>
export default {
    name: "ComparisonBadge",

    props: {
        title: {
            type: String,
            default: ''
        },
        value: {
            type: Number,
            default: 0
        },
        unit: {
            type: String,
            default: ''
        },
        comparisonValue: {
            type: Number,
            default: 0
        },
        comparisonUnit: {
            type: String,
            default: ''
        },
        formatAs: {
            type: String,
            default: 'straightNumber'
        },
        formatComparisonValueAs: {
            type: String,
            default: 'number'
        }
    },

    data() {
        return {
            type: null
        }
    },

    beforeMount() {
        let val = parseFloat(this.value);
        let compVal = parseFloat(this.comparisonValue);
        if (val > compVal) {
            this.type = 'increase';
            return;
        }
        if (val < compVal) {
            this.type = 'decrease';
            return;
        }
        this.type = 'equal';
    },

    computed: {
        comparisonTrend() {
            let diff = (this.comparisonValue - this.value) < 0 ? (this.comparisonValue - this.value) * -1 : this.comparisonValue - this.value;
            return (diff / this.comparisonValue) * 100;
        },
        comparisonTrendStyles() {
            return {
                'text-green-500': this.type === 'increase',
                'bg-green-100': this.type === 'increase',
                'text-red-500': this.type === 'decrease',
                'bg-red-100': this.type === 'decrease',
                'text-gray-500': this.type === 'equal'
            }
        }
    },

    methods: {
        format(val, format) {
            if(format === 'straightNumber') {
                return this.$options.filters.toNumber(val, 0, 0);
            } else if (format ==='number') {
                return this.$options.filters.toNumber(val, 2, 2);
            } else if (format ==='currency') {
                return this.$options.filters.toCurrency(val);
            }
            return val;
        }
    }

}
</script>
